module.exports = __webpack_public_path__ + "media/images/icons/info-9d4cd4065eeff1acfc0f0fb6398c83e3.svg";